module.exports = __webpack_public_path__ + "img/red-packet-line.93c9379e.svg";